// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().max(21),
    name: z.string().max(128),
    description: z.string().max(128),
});
export const Roles = Object.freeze({
    table: 'roles',
    tableSingular: 'role',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
    ],
    createGuard,
    guard,
});
